$.namespace("SCS.backbutton");
SCS.backbutton.hide = function() {
	//if "browser" does not have browsing history then hide the button 
	if (window.history.length < 2) {
		$(document).ready(function() {
			$('.back').hide();
		});
	}
};



//////////////////
// WEBPACK FOOTER
// ./clientlibs/js/etc/designs/help/clientlibs/desktop/js/backButton.js
// module id = 350
// module chunks = 0